export default {
  goBack: {
    id: 'review_form_go_back',
    defaultMessage: 'Go back',
  },
} as const
